export default __webpack_public_path__ + "static/media/2013.3881d189.png";